import React from "react";
import "../styles/categoryGrid.css";

const getCatThumbnailUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;
  const url = originalUrl.replace("/category/", "/cat-thumbnails/");
  const lastDot = url.lastIndexOf(".");
  if (lastDot === -1) return url;
  return url.substring(0, lastDot) + ".webp";
};

const CategoryGrid = ({ categories, onCategoryClick }) => {
  const sortedCategories = [...categories].sort((a, b) => {
    const getOrder = (val) => {
      if (val === null || val === undefined || val === "") return 9999;
      const num = Number(val);
      return isNaN(num) ? 9999 : num;
    };

    const orderA = getOrder(a.order);
    const orderB = getOrder(b.order);

    // ✅ Primary: order
    if (orderA !== orderB) return orderA - orderB;

    // ✅ Secondary: name (for duplicates)
    return (a.category_name || "").localeCompare(b.category_name || "");

    // (optional) tertiary: id (absolute stability)
    // return a.id - b.id;
  });
  return (
    <div className="category-grid-wrapper-card">
      <h2 className="category-grid-title">Shop By Collections</h2>

      <div className="category-grid">
        {sortedCategories.map((cat) => (
          <div
            key={cat.id}
            className="category-card"
            onClick={() => onCategoryClick(cat.id)}
          >
            <img
              src={getCatThumbnailUrl(cat.category_image)}
              alt={cat.category_name}
              loading="lazy"
              decoding="async"
              className="category-img"
              onError={(e) => { if (e.target.src !== cat.category_image) e.target.src = cat.category_image; }}
            />

            <div className="category-overlay">
              <h4>{cat.category_name}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default CategoryGrid;
